/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {
  CustomerInquiryVehicleDetails,
  CustomerInquiryVehicleInformation,
  WorkshopInterestVehicleType,
} from '@dms/api/workshop';

import {VehicleDetailsFormType, VehicleInformationFormType} from '../types';

const DEFAULT_VEHICLE_TYPE: WorkshopInterestVehicleType = 'VEHICLETYPE_PASSENGER_CAR';

export function transformVehicleDetailsToForm(
  details: CustomerInquiryVehicleDetails
): VehicleDetailsFormType {
  return {
    vehicleType: [details.vehicleType],
    licensePlate: details.licensePlate,
    vin: details.vin,
    make: details.make,
    modelFamily: details.modelFamily,
    trim: details.trim,
    variant: details.variant,
    firstRegistration: details.firstRegistration,
    realProductionYear: details.realProductionYear,
    realProductionMonth: details.realProductionMonth,
    vehicleClassId: details.vehicleClassId,
  };
}

export function transformFormToVehicleDetails(
  form: VehicleDetailsFormType
): CustomerInquiryVehicleDetails {
  return {
    vehicleType: (form.vehicleType?.[0] ?? DEFAULT_VEHICLE_TYPE) as WorkshopInterestVehicleType,
    licensePlate: form.licensePlate ?? null,
    vin: form.vin ?? null,
    make: form.make ?? null,
    modelFamily: form.modelFamily ?? null,
    trim: form.trim ?? null,
    variant: form.variant ?? null,
    firstRegistration: form.firstRegistration ?? null,
    realProductionYear: form.realProductionYear ?? null,
    realProductionMonth: form.realProductionMonth ?? null,
    vehicleClassId: form.vehicleClassId ?? null,
  };
}

export function transformVehicleInformationToForm(
  info: CustomerInquiryVehicleInformation
): VehicleInformationFormType {
  return {
    currentMileage: info.currentMileage,
    additionalInformation: info.additionalInformation,
  };
}

export function transformFormToVehicleInformation(
  form: VehicleInformationFormType
): CustomerInquiryVehicleInformation {
  return {
    currentMileage: form.currentMileage ?? null,
    additionalInformation: form.additionalInformation ?? null,
  };
}
